import React, { useMemo, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { FormattedMessage, injectIntl } from "react-intl";
import UsersFilter from "./users-filter/UsersFilter";
import UsersTable from "./users-table/UsersTable";
import { UsersGrouping } from "./users-grouping/UsersGrouping";
import { useUsersUIContext } from "./UsersUIContext";

function UsersCard(props) {
  const { intl } = props;
  const title = intl.formatMessage({ id: "HEADER.MENU.USER" });
  const UsersUIContext = useUsersUIContext();
  const UsersUIProps = useMemo(() => {
    return {
      ids: UsersUIContext.ids,
      newUserButtonClick: UsersUIContext.newUserButtonClick
    };
  }, [UsersUIContext]);

  useEffect(() => {
    console.log("UsersCard refresh ... ");
  }, []);
  return (
    <Card>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={UsersUIProps.newUserButtonClick}
          >
            <FormattedMessage id="MENU.NEW" />
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <UsersFilter />
        {UsersUIProps.ids.length > 0 && <UsersGrouping />}
        <UsersTable />
      </CardBody>
    </Card>
  );
}

export default injectIntl(UsersCard);
